document.addEventListener('DOMContentLoaded', function() {
    const likeButtons = document.querySelectorAll('#likes-mobile, #likes-desk');
    const likesNum = document.querySelectorAll('.likesNum');

    // Set initial state if previously liked

    likeButtons.forEach(button => {
        const idPost = button.getAttribute('data-id-post');
        const hasLiked = localStorage.getItem(`hasLiked-${idPost}`);
        
        if (hasLiked) {
            likeButtons.forEach(button => button.classList.add('liked'));
        }

        button.addEventListener('click', function() {
            if (!localStorage.getItem(`hasLiked-${idPost}`)) {
                const idPost = this.getAttribute('data-id-post');
                const urlLiked = this.getAttribute('data-url-liked');
                fetch(urlLiked, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                    },
                    body: JSON.stringify({ id: idPost })
                })
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    localStorage.setItem(`hasLiked-${idPost}`, 'true');
                    // Update both buttons and counters
                    likeButtons.forEach(btn => btn.classList.add('liked'));
                    const likesQtd = parseInt(likesNum[0].textContent);
                    likesNum.forEach(counter => counter.textContent = likesQtd + 1);
                })
                .catch(error => {
                    alert('Algo deu errado.');
                });
            } else {
                const idPost = this.getAttribute('data-id-post');
                const urlunLiked = this.getAttribute('data-url-unliked');
                fetch(urlunLiked, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                    },
                    body: JSON.stringify({ id: idPost })
                })
                .then(response => {
                    if (!response.ok) throw new Error('Erro ao curtir');
                    localStorage.removeItem(`hasLiked-${idPost}`);
                    likeButtons.forEach(btn => {
                        btn.classList.remove('liked');
                    });
                    const likesQtd = parseInt(likesNum[0].textContent);
                    likesNum.forEach(counter => counter.textContent = likesQtd - 1);
                })
                .catch(() => alert('Algo deu errado ao curtir.'));
            }
            }
        );
    });

    // Share functionality
    const shareLinks = document.querySelectorAll('.share .links a');

    // Get current page URL and title
    const pageUrl = encodeURIComponent(window.location.href);
    const pageTitle = encodeURIComponent(document.querySelector('.blogDetail__banner--title').textContent.trim());

    // Define share URLs
    const shareUrls = {
        facebook: `https://www.facebook.com/sharer/sharer.php?u=${pageUrl}`,
        linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${pageUrl}`,
        whatsapp: `https://api.whatsapp.com/send?text=${pageTitle}%20${pageUrl}`,
        twitter: `https://twitter.com/intent/tweet?url=${pageUrl}&text=${pageTitle}`
    };

    // Add click handlers to share buttons
    shareLinks.forEach((link, index) => {
        link.addEventListener('click', (e) => {
            e.preventDefault();
            const socialNetwork = Object.keys(shareUrls)[index];
            const url = shareUrls[socialNetwork];

            // Open share dialog in popup window
            window.open(
                url,
                'share-dialog',
                'width=800,height=600,toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes'
            );
        });
    });
});
